import { render, staticRenderFns } from "./TicketsChatMessagesItem.vue?vue&type=template&id=a402aba6&"
import script from "./TicketsChatMessagesItem.vue?vue&type=script&lang=js&"
export * from "./TicketsChatMessagesItem.vue?vue&type=script&lang=js&"
import style0 from "./TicketsChatMessagesItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports